import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClTextarea } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-textarea',
    templateUrl: './form-textarea.component.html',
    styleUrls: ['./form-textarea.component.css'],
    imports: [ReactiveFormsModule, ClTextarea, ErrorComponent],
})
export class FormTextareaComponent {
    readonly control = input.required<FormControl<string>>();
    readonly label = input<string>('');
    readonly inputId = input.required<string>();
    readonly placeholder = input<string>('');
    readonly rows = input<number>(4);
}
